import type { EffectiveRole } from '@domain/entities';
import type { IAccessRepository } from '@domain/repositories';

export class GetMyRolesUseCase {
  constructor(private readonly accessRepository: IAccessRepository) {}

  async execute(): Promise<EffectiveRole[]> {
    return this.accessRepository.myRoles();
  }
}
